import { BaseStore } from '../BaseStore';
import { removeRouterBasename } from '../../../utils/locationUtils';
import { BehaviorSubject } from 'rxjs';
import { MEDIA_PLATFORM_UPLOAD_URL } from '../../../server/MediaPlatformService/consts';
import { ViewerWrapper } from '../../../Viewer/ViewerWrapper';
import { httpClient } from '../../../common/utils/httpClient';

interface ClientStoreProps {
  experiments?: any;
  baseUrl?: string;
  assetsBaseUrl?: string;
  staticsBaseUrl?: string;
  storePath?: string;
  storeMode: string;
  viewer: ViewerWrapper;
  docsTree?: any;
  id?: string;
}

export class ClientStore extends BaseStore {
  focusLocation: BehaviorSubject<string>;

  constructor({
    baseUrl,
    assetsBaseUrl,
    staticsBaseUrl,
    storePath,
    experiments,
    viewer,
    storeMode,
    id,
  }: ClientStoreProps) {
    super({
      experiments: experiments || window.__EXPERIMENTS__,
      baseUrl: typeof baseUrl === 'string' ? baseUrl : window.__BASEURL__,
      assetsBaseUrl: assetsBaseUrl || window.__ASSETS_BASE_URL__,
      staticsBaseUrl: staticsBaseUrl || window.__DOCS_STATICS_BASE_URL__,
      storePath: storePath || window.__STORE_PATH__,
      storeMode: storeMode || window.__STORE_MODE__,
      viewer: viewer || window.__VIEWER__,
      id,
    });
    this.focusLocation = new BehaviorSubject('');
  }

  async initStoreData() {
    this.timeStart(`Init Store ${this.viewer.id}`);
    let docsDataURL;

    if (process.env.NODE_ENV !== 'development') {
      docsDataURL = `https://${MEDIA_PLATFORM_UPLOAD_URL}/${this.getStoreKeyInCDN()}/client/docs-data.json`;
    } else {
      const queryParams = window.location.search || '';
      docsDataURL = `/api/v1/docs-data/${this.viewer.id}${queryParams}`;
    }

    const {
      data: { docsTree, guidesTree },
    } = await httpClient.get(docsDataURL);

    this.guidesTree = guidesTree;
    this.docsTree = docsTree;
    this.timeEnd(`Init Store ${this.viewer.id}`);
  }

  subscribeToFocusLocation = (fn) => this.focusLocation.subscribe(fn);

  publishToFocusLocation = (value) => {
    if (value && this.focusLocation.value !== value) {
      const nextValue = removeRouterBasename(value, this.storePath);
      this.focusLocation.next(nextValue);
    }
  };
}
